<template>
	<iframe :src="`${url}`" class="iframe active"  frameborder="no" allowfullscreen="true" style="width: 100%; height: 100%; background: #fff;" ></iframe>
</template>
<script>
export default {
	name: 'contents',
	props: {
		url: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			token:"",
		}
	},
	methods: {},
	created() {},
	mounted() {},
}
</script>

<style scoped></style>
